const c = {
  name: "AdyenForPlatformsAdvanced",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,0c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3s3-1.3,3-3C23,1.3,21.7,0,20,0z M19,3c0-0.5,0.5-1,1-1
			c0.5,0,1,0.5,1,1c0,0.5-0.5,1-1,1C19.5,4,19,3.5,19,3z"/>
		<path class="st0" d="M21.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C20.7,18.7,21.3,19.3,21.3,20z"/>
		<path class="st0" d="M16,21.2c0.7,0,1.2-0.6,1.2-1.2s-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2S15.3,21.2,16,21.2z"/>
		<path class="st0" d="M25.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C24.7,18.7,25.3,19.3,25.3,20z"/>
		<path class="st0" d="M20,10c-2.4,0-4.6,0.8-6.3,2.3l-3-3C10.9,8.9,11,8.4,11,8c0-1.7-1.3-3-3-3C6.3,5,5,6.3,5,8c0,1.7,1.3,3,3,3
			c0.5,0,0.9-0.1,1.3-0.3l3,3C10.8,15.4,10,17.6,10,20c0,5.2,3.9,9.4,9,10v4.2c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3s3-1.3,3-3
			c0-1.3-0.8-2.4-2-2.8V30c4.7-0.5,8.5-4.2,9-9h4.2c0.4,1.2,1.5,2,2.8,2c1.7,0,3-1.3,3-3s-1.3-3-3-3c-1.3,0-2.4,0.8-2.8,2H30
			c-0.2-2-1-3.8-2.2-5.3l3-3c0.4,0.2,0.8,0.3,1.3,0.3c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3c-1.7,0-3,1.3-3,3c0,0.5,0.1,0.9,0.3,1.3l-3,3
			C24.6,10.8,22.4,10,20,10z M12,20c0-4.4,3.6-8,8-8s8,3.6,8,8s-3.6,8-8,8S12,24.4,12,20z M20,36c0.5,0,1,0.5,1,1s-0.5,1-1,1
			c-0.5,0-1-0.5-1-1S19.5,36,20,36z M31,8c0-0.5,0.5-1,1-1c0.5,0,1,0.5,1,1c0,0.5-0.5,1-1,1C31.5,9,31,8.5,31,8z M36,20
			c0-0.5,0.5-1,1-1s1,0.5,1,1c0,0.5-0.5,1-1,1S36,20.5,36,20z M8,7c0.5,0,1,0.5,1,1c0,0.5-0.5,1-1,1C7.4,9,7,8.5,7,8
			C7,7.4,7.4,7,8,7z"/>
		<path class="st0" d="M5,32c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C6.3,35,5,33.7,5,32z M8,31c-0.5,0-1,0.5-1,1
			c0,0.5,0.5,1,1,1c0.5,0,1-0.5,1-1C9,31.5,8.5,31,8,31z"/>
		<path class="st0" d="M0,20c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3s-1.3,3-3,3C1.3,23,0,21.7,0,20z M3,19c-0.5,0-1,0.5-1,1
			c0,0.5,0.5,1,1,1c0.5,0,1-0.5,1-1C4,19.5,3.5,19,3,19z"/>
		<path class="st0" d="M32,29c-1.7,0-3,1.3-3,3c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3C35,30.4,33.7,29,32,29z M31,32c0-0.5,0.5-1,1-1
			c0.5,0,1,0.5,1,1c0,0.5-0.5,1-1,1C31.5,33,31,32.6,31,32z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as AdyenForPlatformsAdvanced
};
